export class Court {
  constructor(
    readonly id_court: string,
    readonly name_court: string,
    readonly integrated: boolean,
    readonly free_of_charge: boolean,
  ) {}
}
